import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/regency?size=520`;

export const ACTION_TYPES = {
  FETCH_REGENCY_LIST: 'province/FETCH_REGENCY_LIST',
  RESET: 'province/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
};

// REDUCER
const regencyReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_REGENCY_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_REGENCY_LIST):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_REGENCY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default regencyReducer;

// ACTIONS
export const getEntities = () => ({
  type: ACTION_TYPES.FETCH_REGENCY_LIST,
  payload: axios.get(apiUrl),
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
